import { computed as g, h as o } from "vue";
import i from "./design-system.es153.js";
/* empty css                    */
import l from "./design-system.es128.js";
const e = {
  name: "DsBox",
  props: {
    /**
     * HTML tag to render the component as
     */
    as: {
      type: String,
      default: "div"
    },
    /**
     * Padding of the box used by all sides
     */
    padding: {
      type: String,
      default: null,
      validator: (d) => i.includes(d)
    },
    /**
     * Padding of the box used by the x-axis
     */
    paddingX: {
      type: String,
      default: null,
      validator: (d) => i.includes(d)
    },
    /**
     * Padding of the box used by the y-axis
     */
    paddingY: {
      type: String,
      default: null,
      validator: (d) => i.includes(d)
    },
    paddingTop: {
      type: String,
      default: null,
      validator: (d) => i.includes(d)
    },
    paddingRight: {
      type: String,
      default: null,
      validator: (d) => i.includes(d)
    },
    paddingBottom: {
      type: String,
      default: null,
      validator: (d) => i.includes(d)
    },
    paddingLeft: {
      type: String,
      default: null,
      validator: (d) => i.includes(d)
    },
    backgroundColor: {
      type: String,
      default: null
    }
  },
  setup(d, { slots: t }) {
    const n = g(() => {
      const a = {
        "--ds-box-padding-top": "0",
        "--ds-box-padding-bottom": "0",
        "--ds-box-padding-left": "0",
        "--ds-box-padding-right": "0"
      };
      return d.padding && (a["--ds-box-padding-top"] = `var(--ds-${d.padding})`, a["--ds-box-padding-bottom"] = `var(--ds-${d.padding})`, a["--ds-box-padding-left"] = `var(--ds-${d.padding})`, a["--ds-box-padding-right"] = `var(--ds-${d.padding})`), d.paddingX && (a["--ds-box-padding-left"] = `var(--ds-${d.paddingX})`, a["--ds-box-padding-right"] = `var(--ds-${d.paddingX})`), d.paddingY && (a["--ds-box-padding-top"] = `var(--ds-${d.paddingY})`, a["--ds-box-padding-bottom"] = `var(--ds-${d.paddingY})`), d.paddingTop && (a["--ds-box-padding-top"] = `var(--ds-${d.paddingTop})`), d.paddingRight && (a["--ds-box-padding-right"] = `var(--ds-${d.paddingRight})`), d.paddingBottom && (a["--ds-box-padding-bottom"] = `var(--ds-${d.paddingBottom})`), d.paddingLeft && (a["--ds-box-padding-left"] = `var(--ds-${d.paddingLeft})`), d.backgroundColor && (a.backgroundColor = `var(--ds-color-${d.backgroundColor})`), a;
    });
    return () => o(
      d.as,
      {
        class: "ds-box",
        style: n.value
      },
      t.default()
    );
  }
}, p = /* @__PURE__ */ l(e, [["__scopeId", "data-v-021b7185"]]);
export {
  p as default
};
//# sourceMappingURL=design-system.es37.js.map
